<div class="app-grid margin-bottom-3">
    <p>{{ 'payroll.run.showSendHoursApprovalReminderModalContent' | translate }}</p>
</div>
<form class="app-grid" #form="ngForm" autocomplete="off">
    <div class="columns-12 margin-bottom-3">
        <mat-label>{{ 'payroll.run.sendTo' | translate }}</mat-label>
        <p>{{ 'payroll.run.recipients' | translate }}</p>
    </div>
    <mat-form-field class="columns-12">
        <mat-label>{{ 'payroll.run.subject' | translate }}</mat-label>
        <input
            matInput
            type="text"
            name="subject"
            #subject="ngModel"
            [(ngModel)]="hoursApprovalReminder.subject"
            required
        />
        <mat-error *ngIf="subject.invalid">{{ subject.errors | formErrors }}</mat-error>
    </mat-form-field>
    <mat-form-field class="columns-12">
        <mat-label>{{ 'payroll.run.message' | translate }}</mat-label>
        <textarea
            rows="6"
            name="messageBody"
            #messageBody="ngModel"
            [(ngModel)]="hoursApprovalReminder.messageBody"
            required
            matInput
        ></textarea>
        <mat-error *ngIf="messageBody.invalid">{{ messageBody.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
